/**
 * @desc Settings hash
 * @depends CT Bootstrap, jQuery
 */
!function(module){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/settings',['common/settings'], module)
	else
	//>>excludeEnd("requireTmpl");
		module()
}(function(){
	$.extend(CT.settings || {}, {
			zomato:{
		    url: 'http://' + window.location.host + '/smallworld/zomato_search_api',
		    limit: '8',
		    radius: '30'
		},
		urlDelimiter : '&',
		srpRenderTime: '',
		general: {
			quickLookClickCount : 0, // used for getting the number of clicks 
			locationRadius : 1, //radius to show nearby hotels in location search
			totalQuickLookOpenForGN : 5, //configured -Total number of hotel details clicked to open GN
			showFirstRun : false,
			ptypeMap: {
				"BH" : "Boutique Hotel",
				"GH" : "Guest House",
				"HH" : "Heritage Hotel",
				"HS" : "Homestay",
				"RS" : "Resort",
				"SA" : "Serviced Apartment",
				"SP" : "Spa",
				"HB" : "Houseboat",
				"CA" : "Casino",
				"MOT" : "Motel",
				"BNB" : "Bed and Breakfast",
				"CAS" : "Castle",
				"FRM" : "Farm",
				"STE" : "Suites",
				"EXT" : "Extended Stay",
				"CTR" : "Conventions/Conference Center",
				"VL"  : "Villa",
				"LYC" : "Luxury Yacht",
				"RJI" : "Ryokan (Japanese Inn)",
				"HST" : "Hostel",
				"CPG" : "Camping Ground",
				"APT" : "Apartment",
				"Hostel":"Hostel",
				"Apartment": "Apartment",
				"Dorm" : "Dorm",
				"House" : "House",
				"Villa" : "Villa",
				"Treehouse":"Treehouse",
				"Tent":"Tent",
				"Loft":"Loft",
				"Chalet":"Chalet",
				"Other": "Other",
				"Castle":"Castle",
				"Boat":"Boat",
				"Townhouse":"Townhouse",
				"Condominium":"Condominium",
				"Earth House":"Earth House",
				"GS":"GS",
				"Bungalow": "Bungalow",
				"BEA": "Beach Hut",
				"COT": "Cottage",
				"PAL": "Palace",
				"ASH": "Ashram/Dharamshala",
				"TRE": "Tree House",
				"SUI": "All Suites",
				"BUN": "Bungalow",
				"LOD": "Lodge",
				"VIP": "Rooms in a Property",
				"VIW": "Entire Property",
				"HOT": "Hotel"
			},
			mapApiKey : 'AIzaSyBICejdTstEMJamaR3_1yVvohjIhLikbCM',
			mapApiKeyCP: 'AIzaSyCMJDSBD1Jd8dPLIuQjRhARJ9n0anyV9EA',//@Meraj-Created New api key for corp domains with Sarah's gmailid
			staticMapToCityId :{
				"32131":"agraMap",
				"32136":"ahmedabadMap",
				"32257":"amritsarMap",
				"32550":"bangaloreMap",
				"100073":"bangkokMap",
				"33013" :"chandigarhMap",
				"33070" :"chennaiMap",
				"37235":"coorgMap",
				"100074":"dubaiMap",
				"33752":"gurgaonMap",
				"100075":"hongkongMap",
				"33897":"hyderabadMap",
				"100990":"istanbulMap",
				"33968":"jaipurMap",
				"37269":"kathmanduMap",
				"34571":"kochiMap",
				"34574":"kodaikanalMap",
				"34600":"kolkataMap",
				"100079":"kualalumpurMap",
				"34842":"lonavalaMap",
				"100113":"londonMap",
				"34849":"lucknowMap",
				"34887":"mahabaleshwarMap",
				"34981":"manaliMap",
				"33719":"mumbaiMap",
				"37275":"munnarMap",
				"35284":"mysoreMap",
				"35485":"newdelhiMap",
				"100211":"newyorkMap",
				"106258":"ootyMap",
				"37264":"panajiMap",
				"100115":"parisMap",
				"35890":"pondicherryMap",
				"35906":"portblairMap",
				"35943":"puneMap",
				"100117":"romeMap",
				"36461":"shimlaMap",
				"36463":"shirdiMap",
				"100076":"singaporeMap",
				"36881":"tirupatiMap",
				"36928":"udaipurMap",
				"37069":"varanasiMap",
				"generic":"genericMap"
			},
			amenitiesMap: [{
				"title" : "WiFi",
				"class" : "amWIFI",
				"bit":9
			}, {
				"title" : "Air Conditioner",
				"class" : "amAC",
				"bit":8
			}, {
				"title" : "24h Check in",
				"class" : "am24HrCheckin",
				"bit":16
			}, {
				"title" : "Restaurant",
				"class" : "amRestaurant",
				"bit":7
			}, {
				"title" : "Bar",
				"class" : "amBar",
				"bit":6
			}, {
				"title" : "Cafe",
				"class" : "amCafe",
				"bit":5
			}, {
				"title" : "Room Service",
				"class" : "amRoomService",
				"bit":4
			}, {
				"title" : "Internet",
				"class" : "amInternet",
				"bit":3
			}, {
				"title" : "Business Center",
				"class" : "amBusinessCenter",
				"bit":2
			}, {
				"title" : "Pool",
				"class" : "amPool",
				"bit":1
			}, {
				"title" : "Gym",
				"class" : "amGym",
				"bit":0
			},
			{
				"title" : "Airport Shuttle",
				"class" : "amAirportShuttle",
				"bit":10
			},
			{
				"title" : "Pick & Drop",
				"class" : "amPickDrop",
				"bit":11
			},
			{
				"title" : "Free Parking",
				"class" : "amParking",
				"bit":14
			},
			{
				"title" : "Spa",
				"class" : "amSpa",
				"bit":15
			},
			{
				"title" : "Card Payment Available",
				"class" : "amCardPayment",
				"bit":12
			},
			{
				"title" : "24h Front Desk",
				"class" : "am24HrFrontDesk",
				"bit":13
			}
			],
			 roomAmenitiesMap: [{
				"title" : "Air conditioning",
				"class" : ""
			}, {
				"title" : "Color television",
				"class" : ""
			}, {
				"title" : "Hair dryer",
				"class" : ""
			}, {
				"title" : "Internet access",
				"class" : ""
			}, {
				"title" : "Iron",
				"class" : ""
			}, {
				"title" : "Minibar",
				"class" : ""
			}, {
				"title" : "Newspaper",
				"class" : ""
			}, {
				"title" : "Pets allowed",
				"class" : ""
			}, {
				"title" : "Private bathroom",
				"class" : ""
			}, {
				"title" : "Refrigerator",
				"class" : ""
			}, {
				"title" : "Safe",
				"class" : ""
			}, {
				"title" : "Telephone",
				"class" : ""
			}]
		},
		dp : {
			infScrollCount : 10,
			urls : CT.settings.localhost? {
				search : "/dp/json/search.json"
			} : {
				search : "/packages/search/results",
				dpTrust : "/hotels/service/pkgRateInfo?{{#pm}}{{{pm}}}&{{/pm}}ct_hotelid={{hotelId}}&imgInc=true"
			},

			updatingMsgs : {
				flight: {
					msg: "Updating all packages with newly selected flights"
				},
				hotel: {
					msg: "Updating package with the new room type"
				},
				dp : {
					msg : "Updating Packages"
				},
				//this is used in packages show all localities modal window
				hotel_fs : {
					msg : "Updating Packages"
				}
			},

			filters : {
				//filter acts only on this array of ids
				ids : "ids",
				//if ids is not passed, filters act only on loc ( array of attribute values )
				loc : "loc",
				//or condition for the following attribute list
				or : ["pt", "badgeFilter"],
				//and condition for the following attribute list
				and : ["am"],
				//range condition for the following attribute list
				range : ["price", "taStar", "star"],
				attrMap : {
					taStar : "data-tastar",
					star : "data-star",
					loc : "data-area-poi",
					price : "data-price",
					pt : "data-pt"
				},
				constants:{
					locCheckboxText : "data-flt=area data-location=a",
					locAreaFilterCnt : 3,
					areaPoiRadius : 3,
					propertyHash : {
//						"BH" : "Boutique Hotel","GH" : "Guest House","HH" : "Heritage Hotel","HS" : "Homestay","RS" : "Resort",
//						"SA" : "Serviced Apartment","SP" : "Spa","HB" : "Houseboat","CA" : "Casino","MOT" : "Motel","BNB" : "Bed and Breakfast",
//						"CAS" : "Castle","FRM" : "Farm","STE" : "Suites","EXT" : "Extended Stay","CTR" : "Conventions/Conference Center","APT" : "Apartment"
						"BH" : "Boutique Hotel",
						"GH" : "Guest House",
						"HH" : "Heritage Hotel",
						"HS" : "Homestay",
						"RS" : "Resort",
						"SA" : "Serviced Apartment",
						"SP" : "Spa",
						"HB" : "Houseboat",
						"CA" : "Casino",
						"MOT" : "Motel",
						"BNB" : "Bed and Breakfast",
						"CAS" : "Castle",
						"FRM" : "Farm",
						"STE" : "Suites",
						"EXT" : "Extended Stay",
						"CTR" : "Conventions/Conference Center",
						"VL"  : "Villa",
						"LYC" : "Luxury Yacht",
						"RJI" : "Ryokan (Japanese Inn)",
						"HST" : "Hostel",
						"CPG" : "Camping Ground",
						"APT" : "Apartment",
						"Hostel":"Hostel",
						"Apartment": "Apartment",
						"Dorm" : "Dorm",
						"House" : "House",
						"Villa" : "Villa",
						"Treehouse":"Treehouse",
						"Tent":"Tent",
						"Loft":"Loft",
						"Chalet":"Chalet",
						"Other": "Other",
						"Castle":"Castle",
						"Boat" :"Boat",
						"Townhouse":"Townhouse",
						"Condominium":"Condominium",
						"Earth House":"Earth House",
						"GS":"GS",
						"Bungalow": "Bungalow",
						"BEA": "Beach Hut",
						"COT": "Cottage",
						"PAL": "Palace",
						"ASH": "Ashram/Dharamshala",
						"TRE": "Tree House",
						"SUI": "All Suites",
						"BUN": "Bungalow",
						"LOD": "Lodge",
						"VIP": "Rooms in a Property",
						"VIW": "Entire Property",
						"HOT": "Hotel"
					},
					airlineCombinations:{
						"9W-K":["9W-K","S2"]
					}
				}
			},
			phoneNo : {
				customerService : '',
				phoneSales : ''
			}
		},

		hotel : {
			lolfilter: {
				"New Delhi": [
					"Airport Zone-Mahipalpur",
					"Connaught Place-Central Delhi",
					"Paharganj - Central Delhi",
					"Karol Bagh - Central Delhi"
				],
				"Mumbai": [
					// "Andheri East-International Airport",
					"Domestic Airport",
					"Juhu",
					"South Mumbai Vicinity",
					"Powai",
					"Thane"
				],
				"Chennai": [
					"US Consulate",
					"Egmore",
					"Airport Zone",
					"Chennai Central",
					"T Nagar-City Centre"
				],
				"Bangalore": [
					"MG Road",
					"City Centre",
					"International Airport Road",
					"Gandhi Nagar",
					"Electronic City"
				],
				"Hyderabad": [
					"Hitech City",
					"Banjara Hills",
					"Lakdi ka Pul",
					"Airport Zone",
					"Secunderabad"
				],
				"Pune": [
					"Viman Nagar",
					"Hinjewadi",
					"Shivaji Nagar",
					"Koregaon Park",
					"Pimpri Chinchwad"
				],
				"Jaipur": [
					"Airport Zone",
					"Bani Park",
					// "City Centre-Near Railway Station",
					"MI Road",
					"Tonk Road",
					"Civil Lines",
					"Kukas(Delhi-Jaipur NH8)"
				],
				"Ahmedabad": [
					"SG Highway",
					"Ashram Road",
					"Airport Zone",
					"Ellisbridge",
					"Navrangpura"
				],
				"Kolkata": [
					"Airport Zone",
					"Park Street and Vicinity",
					"Esplanade-New market",
					"New Town - Rajarhat",
					"Minto Park Area"
				],
				"Goa": [
					"Candolim Beach-North Goa",
					"Panjim",
					"Baga Beach-North Goa",
					"Colva Beach-South Goa",
					"Calangute Beach-North Goa"
				]
			},
			tagsFilterPriority: {
				"Goa":[
					"Beach nearby",
					"On the beach",
					"Sea view",
					"Couple friendly",
					"Romantic",
					"Infinity pool",
					"Good nightlife nearby"
				],
				"Udaipur":[
					"Lake view",
					"Heritage",
					"Couple friendly",
					"Good nightlife nearby",
					"24 hours room service",
					"Luxury"
				],
				"Pondicherry":[
					"Beach nearby",
					"Sea view",
					"Couple friendly",
					"Popular attractions nearby",
					"24 hours room service",
					"Heritage"
				],
				"Dubai":[
					"Sea view",
					"Burj Khalifa View",
					"Shopping districts nearby",
					"Beach nearby",
					"Kid friendly",
					"Good nightlife nearby"
				],
				"Visakhapatnam":[
					"Sea view",
					"Beach nearby",
					"Couple friendly",
					"Romantic",
					"Luxury",
					"Popular attractions nearby"
				],
				"Jaipur":[
					"Couple friendly",
					"Heritage",
					"Luxury",
					"Popular attractions nearby",
					"Good nightlife nearby",
					"24 hours room service"
				],
				"Mahabaleshwar":[
					"Hill view",
					"Luxury",
					"Romantic",
					"Popular attraction nearby",
					"24 hours room service",
					"Parking"
				],
				"Ooty":[
					"Hill view",
					"Couple friendly",
					"Romantic",
					"Luxury",
					"24 hours room service",
					"Heritage"
				],
				"Wayanad":[
					"Hill view",
					"Romantic",
					"Couple friendly",
					"Infinity Pool",
					"Lake View",
					"Luxury"
				],
				"Coorg":[
					"Hill view",
					"Romantic",
					"Infinity Pool",
					"Couple friendly",
					"Popular attractions nearby",
					"Luxury"
				],
				"Manali":[
					"Hill view",
					"Romantic",
					"Couple friendly",
					"Popular attractions nearby",
					"Luxury",
					"Unique Accommodations"
				],
				"Agra":[
					"Romantic",
					"Couple friendly",
					"Luxury",
					"Popular attractions nearby",
					"Heritage",
					"Good nightlife nearby"
				],
				"Jodhpur":[
					"Hill view",
					"Luxury",
					"Couple friendly",
					"Heritage",
					"Unique Accommodations",
					"Popular attractions nearby"
				],
				"Sharjah":[
					"Beach nearby",
					"Sea view",
					"On the beach",
					"Unique Accommodations",
					"Good nightlife nearby",
					"Infinity pool"
				],
				"Istanbul":[
					"Sea view",
					"Blue Mosque view",
					"Popular Attractions nearby",
					"Bosphorus view",
					"Near Old Town",
					"Shopping districts nearby",
					"Hagia Sophia view"
				],
				"Singapore":[
					"Marina view",
					"Popular Attractions nearby",
					"Sea view",
					"Kid friendly",
					"Infinity pool",
					"Above 50th floor"
				],
				"Manali":[
					"Hill view",
					"Romantic",
					"Popular attractions nearby",
					"Luxury",
					"Filler position to make it five"
				],
				"Munnar":[
					"Hill View",
					"Lake view",
					"Couple friendly",
					"Unique accommodations nearby",
					"Filler position to make it five"
				],
				"Ooty":[
					"Hill View",
					"Lake view",
					"Romantic",
					"Popular attractions nearby",
					"Filler position to make it five"
				],
				"Haridwar":[
					"Ganga view",
					"Parking",
					"Heritage",
					"Popular attractions nearby",
					"Filler position to make it five"
				]
			},
			searchParamKeys: ["from","city","state","country","dest_code","chk_in","chk_out"],
			infScrollCount : parseInt(window.hotelListScrollCount),
			mapElePerPage : 10,
			rcntSearchTrigger: window.enableRecentView ? 2 : 3,
			inspectLetCity:["37264","33719"],
			ignoreCityPoi:["37264"],
			wysiwyp:1,
			quickeysExpire:10,
			twoColAmPriority : [{'am24HrCheckin': true,'amAC':false,'amWIFI':true,'amBar':true},{'am24HrCheckin':false,'amWIFI':false,'amBar':false,'amAC':true}],
			cleanUrlParams :["from","trip_type"],
			weekendDestinations :["Bangalore","New Delhi","Mumbai","Chennai","Chandigarh","Kolkata","Hyderabad","Pune","Kochi"],
			autoCompleteUrl:  //(window.isWl == "true") ? "/places/hac?&intl=false&v=2&s=" :
				"//platform" + (location.hostname.split('.')[0].indexOf('qa2') > -1 ? 'qa2' : '')
				+ ".cleartrip.com/hotels/auto-suggest/v3?" +
				(window.isWl == "true" ? 'intl=false&' : '') +
				"c=" +(window.countryCode ? window.countryCode.toUpperCase() : '') + "&s=",
			hotelRatesCallDone:false,
			airBnbRatesCallDone:false,
			autoCompleteUrlTmp : "/places/hac?&s=", //will be used it for internal release..needs to removed
			airBnbCallStatus : {"staticCall":false,"scDataCall":false,"sidDataCall":false,"startIdx":0,"endIdx":200,"increment":200,"resultsType":"ALL","airBnbCall":false},
			royalSliderAttrObj :{fullscreen : {enabled : false, nativeFS : false},controlNavigation : 'none',loop : false,imageScalePadding : 0,autoCenter : true,imageAlignCenter : true,imageScaleMode:"fill",numImagesToPreload : parseInt(window.imgPreLoad),arrowsNavAutohide : true,arrowsNavHideOnTouch : true,keyboardNavEnabled : false, transitionSpeed:300,sliderDrag:false},
			enableBgSearch:(window.enableBgSearch == "true")?true:false,
			airBnb : {
				urls :{
					hotelContent : "/hotels/jsonservice/hotel-dynamic-content",
					scData : "/hotels/service/dynamic-connector/initSearch",
					updateCall : "/hotels/service/sid-results?sid=${sid}&index=${index}&count=${count}",
					updateCallTimer:0
				}
			},
			airBnbSortersToHide : ["featuredSort","dealSort","taSort"],
			airBnbFilters : ["price","instantBooking","roomType","propertyType"],
			twoColUspMap: {
				"location" :{text:"Location friendly"}
			},
		
			// priceRange: {"budget":[0,20],"mid":[20,80],"expensive":[80,100]},
			priceRange: {
				"bottomLow":0,
				"bottomHigh":2000,
				"midLow":4000,
				"midHight":6000,
				"expensive": Infinity,
				"NClasses":['count2k','count4k','count6k','count6kPlus']
			},
			
			twoColUspMap: {
				"location" :{text:"Location friendly"}
			},
			/*This cities added to show "busy weekend message"-- replace with CT.messages.msgWGateWays message*/
			wgCitylist : [{"Coorg":{"c":"Bangalore","s":"Karnataka"}},{"Ooty":{"c":"Bangalore","s":"Karnataka"}},{"Munnar":{"c":"Bangalore","s":"Karnataka"}},{"Mysore":{"c":"Bangalore","s":"Karnataka"}},{"Kodaikanal":{"c":"Bangalore","s":"Karnataka"}},{"Alleppey":{"c":"Bangalore","s":"Karnataka"}},{"Thekkady":{"c":"Bangalore","s":"Karnataka"}},{"Kumarakom":{"c":"Bangalore","s":"Karnataka"}},{"Varkala":{"c":"Bangalore","s":"Karnataka"}},{"Chikmaglur":{"c":"Bangalore","s":"Karnataka"}},{"Hassan":{"c":"Bangalore","s":"Karnataka"}},{"Karwar":{"c":"Bangalore","s":"Karnataka"}},{"Kochi":{"c":"Kochi","s":"Kerala"}},{"Wayanad":{"c":"Bangalore","s":"Karnataka"}},{"Kovalam":{"c":"Kochi","s":"Kerala"}},{"Trivandrum":{"c":"Kochi","s":"Kerala"}},{"Kozhikode":{"c":"Kochi","s":"Kerala"}},{"Kannur":{"c":"Kochi","s":"Kerala"}},{"Guruvayoor":{"c":"Kochi","s":"Kerala"}},{"Kollam":{"c":"Kochi","s":"Kerala"}},{"Kottayam":{"c":"Kochi","s":"Kerala"}},{"Udupi":{"c":"Bangalore","s":"Karnataka"}},{"Puttaparthi":{"c":"Bangalore","s":"Karnataka"}},{"Bandipur":{"c":"Bangalore","s":"Karnataka"}},{"Tirupati":{"c":"Bangalore","s":"Karnataka"}},{"Kumbakonam":{"c":"Kochi","s":"Kerala"}},{"Tiruvannamalai":{"c":"Chennai","s":"Tamil Nadu"}},{"Vellore":{"c":"Bangalore","s":"Karnataka"}},{"Jaipur":{"c":"New Delhi","s":"Delhi"}},{"Manali":{"c":"New Delhi","s":"Delhi"}},{"Udaipur":{"c":"New Delhi","s":"Delhi"}},{"Agra":{"c":"New Delhi","s":"Delhi"}},{"Shimla":{"c":"New Delhi","s":"Delhi"}},{"Amritsar":{"c":"New Delhi","s":"Delhi"}},{"Jodhpur":{"c":"New Delhi","s":"Delhi"}},{"Mussoorie":{"c":"New Delhi","s":"Delhi"}},{"Haridwar":{"c":"New Delhi","s":"Delhi"}},{"Nainital":{"c":"New Delhi","s":"Delhi"}},{"Katra":{"c":"New Delhi","s":"Delhi"}},{"Varanasi":{"c":"New Delhi","s":"Delhi"}},{"Rishikesh":{"c":"New Delhi","s":"Delhi"}},{"Srinagar":{"c":"New Delhi","s":"Delhi"}},{"Dharamshala":{"c":"New Delhi","s":"Delhi"}},{"Pahalgam":{"c":"New Delhi","s":"Delhi"}},{"Dalhousie":{"c":"New Delhi","s":"Delhi"}},{"Leh":{"c":"New Delhi","s":"Delhi"}},{"Gulmarg":{"c":"New Delhi","s":"Delhi"}},{"Kasauli":{"c":"New Delhi","s":"Delhi"}},{"Kullu":{"c":"New Delhi","s":"Delhi"}},{"Kausani":{"c":"New Delhi","s":"Delhi"}},{"Ranikhet":{"c":"New Delhi","s":"Delhi"}},{"Kumbalgarh":{"c":"New Delhi","s":"Delhi"}},{"Almora":{"c":"New Delhi","s":"Delhi"}},{"Jhansi":{"c":"New Delhi","s":"Delhi"}},{"Chail":{"c":"New Delhi","s":"Delhi"}},{"Ranakpur":{"c":"New Delhi","s":"Delhi"}},{"Chittorgarh":{"c":"New Delhi","s":"Delhi"}},{"Kufri":{"c":"New Delhi","s":"Delhi"}},{"Palampur":{"c":"New Delhi","s":"Delhi"}},{"Mandawa":{"c":"New Delhi","s":"Delhi"}},{"Nathdwara":{"c":"New Delhi","s":"Delhi"}},{"Bhimtal":{"c":"New Delhi","s":"Delhi"}},{"Chamba":{"c":"New Delhi","s":"Delhi"}},{"Binsar":{"c":"New Delhi","s":"Delhi"}},{"Dhanaulti":{"c":"New Delhi","s":"Delhi"}},{"Khajjiar":{"c":"New Delhi","s":"Delhi"}},{"Fatehpur Sikri":{"c":"New Delhi","s":"Delhi"}},{"Jaisalmer":{"c":"New Delhi","s":"Delhi"}},{"CORBETT":{"c":"New Delhi","s":"Delhi"}},{"Pushkar":{"c":"New Delhi","s":"Delhi"}},{"Bikaner":{"c":"New Delhi","s":"Delhi"}},{"Mount Abu":{"c":"New Delhi","s":"Delhi"}},{"Sawai Madhopur":{"c":"New Delhi","s":"Delhi"}},{"Ajmer":{"c":"New Delhi","s":"Delhi"}},{"Jammu":{"c":"New Delhi","s":"Delhi"}},{"Bharatpur":{"c":"New Delhi","s":"Delhi"}},{"MATHURA":{"c":"New Delhi","s":"Delhi"}},{"Alwar":{"c":"New Delhi","s":"Delhi"}},{"Neemrana":{"c":"New Delhi","s":"Delhi"}},{"Parwanoo":{"c":"New Delhi","s":"Delhi"}},{"Sariska":{"c":"New Delhi","s":"Delhi"}},{"Mahabalipuram":{"c":"Chennai","s":"Tamil Nadu"}},{"Kanyakumari":{"c":"Chennai","s":"Tamil Nadu"}},{"Trichy":{"c":"Chennai","s":"Tamil Nadu"}},{"Yercaud":{"c":"Chennai","s":"Tamil Nadu"}},{"Tanjore":{"c":"Chennai","s":"Tamil Nadu"}},{"Rameswaram":{"c":"Chennai","s":"Tamil Nadu"}},{"Velankanni":{"c":"Chennai","s":"Tamil Nadu"}},{"Gangtok":{"c":"Kolkata","s":"West Bengal"}},{"Darjeeling":{"c":"Kolkata","s":"West Bengal"}},{"Puri":{"c":"Bhubaneshwar","s":"Orissa"}},{"Shillong":{"c":"Kolkata","s":"West Bengal"}},{"Digha":{"c":"Kolkata","s":"West Bengal"}},{"Pelling":{"c":"Kolkata","s":"West Bengal"}},{"KALIMPONG":{"c":"Kolkata","s":"West Bengal"}},{"Kaziranga":{"c":"Kolkata","s":"West Bengal"}},{"Goa":{"c":"Mumbai","s":"Maharashtra"}},{"Shirdi":{"c":"Mumbai","s":"Maharashtra"}},{"Pondicherry":{"c":"Chennai","s":"Tamil Nadu"}},{"Mahabaleshwar":{"c":"Mumbai","s":"Maharashtra"}},{"Lonavala":{"c":"Mumbai","s":"Maharashtra"}},{"KHAJURAHO":{"c":"Mumbai","s":"Maharashtra"}},{"Daman":{"c":"Mumbai","s":"Maharashtra"}},{"Sasan Gir":{"c":"Mumbai","s":"Maharashtra"}},{"Saputara":{"c":"Mumbai","s":"Maharashtra"}},{"Port Blair":{"c":"Chennai","s":"Tamil Nadu"}},{"Silvassa":{"c":"Mumbai","s":"Maharashtra"}},{"Ganpatipule":{"c":"Mumbai","s":"Maharashtra"}},{"Pench":{"c":"Mumbai","s":"Maharashtra"}},{"Havelock Island":{"c":"Mumbai","s":"Maharashtra"}},{"Igatpuri":{"c":"Mumbai","s":"Maharashtra"}},{"Neil Island":{"c":"Mumbai","s":"Maharashtra"}},{"Aurangabad":{"c":"Mumbai","s":"Maharashtra"}},{"Nashik":{"c":"Mumbai","s":"Maharashtra"}},{"Kanha":{"c":"Mumbai","s":"Maharashtra"}},{"Alibaug":{"c":"Mumbai","s":"Maharashtra"}},{"Matheran":{"c":"Mumbai","s":"Maharashtra"}},{"Kolhapur":{"c":"Mumbai","s":"Maharashtra"}},{"Pachmarhi":{"c":"Mumbai","s":"Maharashtra"}},{"Dwarka":{"c":"Mumbai","s":"Maharashtra"}},{"Ujjain":{"c":"Mumbai","s":"Maharashtra"}},{"Diu":{"c":"Mumbai","s":"Maharashtra"}},{"Khandala":{"c":"Mumbai","s":"Maharashtra"}},{"Ratnagiri":{"c":"Mumbai","s":"Maharashtra"}},{"Kutch":{"c":"Mumbai","s":"Maharashtra"}},{"Chiplun":{"c":"Mumbai","s":"Maharashtra"}},{"Lavasa":{"c":"Mumbai","s":"Maharashtra"}},{"Kashid":{"c":"Mumbai","s":"Maharashtra"}},{"Bekal":{"c":"Bangalore","s":"Karnataka"}},{"Hampi":{"c":"Bangalore","s":"Karnataka"}},{"Ahmedabad":{"c":"Mumbai","s":"Maharashtra"}},{"Chandigarh":{"c":"New Delhi","s":"Delhi"}},{"Coimbatore":{"c":"Bangalore","s":"Karnataka"}},{"Visakhapatnam":{"c":"Hyderabad","s":"Andhra Pradesh"}}],
			urls : CT.settings.localhost? {
				pers : "/hotelstatic/json/pers-all.json",
				search : "/hotelstatic/json/search.json?${params}",
				hotelContent : "/hotels/jsonservice/hotel-content",
				scData : "/hotels/service/scData",
				//updateCall : "/hotelstatic/json/search1.json?${params}",
				updateCall : "/hotels/service/sid-results?sid=${sid}&index=${index}&count=${count}",
				trust : "/hotelstatic/json/sample-tc-resp.json",
				thumbnails : "/hotelstatic/json/sample-images.json",
				resultsJs : window.hotelBaseLink+"/javascripts/search/hotels.results.min"+window.hotels_results_min_js_ver+".js",
				gmapHotelsJs : window.hotelBaseLink+"/javascripts/search/maps.min"+window.maps_min_js_ver+".js"
			} : {
				pers : '/hotelstatic/json/pers-all.json',
				search : "/hotels/service/dynamicSearch",
				hotelContent : window.hotelContentUrl,
				scData : "/hotels/service/scData",
				updateCall :"/hotels/service/sid-results?sid=${sid}&index=${index}&count=${count}",
				trust : "/hotels/service/rateInfo?{{#pm}}{{{pm}}}&{{/pm}}ct_hotelid={{hotelId}}&imgInc=true",
				thumbnails : "/hotels/service/images?hotelId={{hotelId}}",
				resultsJs :  window.hotelBaseLink+"/javascripts/search/hotels.results.min"+window.hotels_results_min_js_ver+".js",
				gmapHotelsJs : window.hotelBaseLink+"/javascripts/search/maps.min"+window.maps_min_js_ver+".js"
			},

			wg : {
				cleanUrlParams :["city","poi","area","hotelName","trip_type"],
				autoCompleteUrl : "/places/hac?&v=2&g=1&s=",
				urls :{
					hotelContent : window.getawayContentUrl,
					//hotelContent : "/hotelstatic/json/wg.json",
					//scData : "/hotels/service/scData",
					scData : "/hotels/service/getaway/scData",
					updateCall : "/hotels/service/sid-results?sid=${sid}&index=${index}&count=${count}",
				},
				hrsSliderOptions :{min: 0,max: 10,step: 2,range: true,values:[0,10],name:"hrsFilterSlider"},
				hotelsThemeTextMap: {
					"pf" :{id:"Pet-friendly",cls:"petFriendly",text:"Take your pets along"}, //pet friendly
					"kf":{id:"Family",cls:"kidFriendly",text:"Recommended for families & groups"}, //kid friendly
					"bs":{id:"Beachside",cls:"beachSide",text:"Beach facing property"},//Beach side
					"f":{id:"Farm",cls:"farms",text:"Experience a farm stay"},//farms
					"he":{id:"Heritage",cls:"heritage",text:"Enjoy a heritage property"},//Heritage
					"l":{id:"Luxury",cls:"luxury",text:"Get pampered in a luxurious getaway"},//luxury
					"ls":{id:"Lakeside",cls:"lakeSide",text:"Serene lake view"},//lake side
					"pv":{id:"Pure-veg",cls:"pureVeg",text:"Vegetarian fare only"},//pure veg
					"r":{id:"Romantic",cls:"romantic",text:"Perfect for a romantic escape"},//romantic
					"rs":{id:"Riverside",cls:"riverSide",text:"Experience the river side"},//riverside
					"vv":{id:"Valley-view",cls:"valleyView",text:"Experience the mountains"},//valley view
					"wf":{id:"Waterfalls",cls:"waterFalls",text:"Waterfall views near this hotel"}//water falls
				},
				/*destinationsThemeTextMap: {
					"pf" : {cls:"petFriendly",text:"You can take your pets along"}, //pet friendly
					"kf":{cls:"kidFriendly",text:"Family"}, //kid friendly
					"bs":{cls:"beachSide",text:"Beachside"},//Beach side
					"f":{cls:"farms",text:"Farm"},//farms
					"he":{cls:"heritage",text:"Heritage"},//Heritage
					"l":{cls:"luxury",text:"Luxury"},//luxury
					"ls":{cls:"lakeSide",text:"Lakeside"},//lake side
					"pv":{cls:"pureVeg",text:"pure veg"},//pure veg
					"r":{cls:"romantic",text:"Romantic"},//romantic
					"rs":{cls:"riverSide",text:"Riverside"},//riverside
					"vv":{cls:"valleyView",text:"Valley-view"},//valley view
					"wf":{cls:"waterFalls",text:"Waterfalls"}//water falls
				},*/
			},
			filter: {
				"interests": {
					"shopping": ["Panjim", "Mapusa-North Goa", "Anjuna", "Arpora-North+Goa"],
					"heritage": ["Arambol", "Siolim", "Aguada", "Mapusa", "Assagao", "Arpora", "Baga", "Ponda", "Dona Paula", "Majorda", "Colva", "Benaulim", "Margao", "Cavolessim", "Varca", "Panjim", "Morjim"],
					"nightlife": ["Calangute", "Baga", "Candolim"],
					"nature": ["Pequeno", "Chorla", "Ghats", "Dudhsagar", "Chorao", "Mahdei", "Dudhsagar", "Panjim", "Margao", "Arambol"],
				},
				nearByCities: {
					checkAll: true,
					id: 'NearByCities',
					elements: [
						{
							dispName: 'Show nearby cities'
						}
					]
				},
				printQuote: {
					desc: "Print quotation",
					qtCls : "printHt",
					icon : 'print'
				},
				emailQuote: {
					desc: "Send quotation",
					qtCls : "emailHt",
					icon : 'mail'
				},
				taStarRating: {
					title: 'TripAdvisor rating',
					labelLeft: 'Any rating',
					min: 1,
					max: 5,
					range: 'max',
					altFiltersClass:'getawaysFilter taFilterWrapper',
					addAltFiltersClass:true
				},
				taRating:{
                    title:"Traveller rating",
                    inline:"inline",
                    showAll:true,
                    checkAll:false,
                    taIcon:true,
                    elements:[
                    	{
                    		displayName:"4.5 and Above",
                    		rvIcon:1,
                    		value:'4.5-5',
                    		val:"45",
                    		svg:'<svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle-half"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg>'
                    		//count:0
                    	},
                    	{
                    		displayName:"4 and Above",
                    		rvIcon:1,
                    		value:'4-5',
                    		val:"4",
                    		svg:'<svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle-empty"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg>'
                    		//count:0
						},
						{
                    		displayName:"3.5 and Above",
                    		rvIcon:1,
                    		value:'3.5-5',
                    		val:"35",
                    		svg:'<svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle-empty"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle-half"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg>'
                    		//count:0
						},
						{
                    		displayName:"3 and Above",
                    		rvIcon:1,
                    		value:'3-5',
                    		val:"3",
                    		svg:'<svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle-empty"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle-empty"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg><svg class="taGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tacircle"></use></svg>'
                    		//count:0
                    	}
                    ],
                    smartFilterCheckBox:1
				},
				price: {
					title: 'Price',
					staticRange: true,
					altFiltersClass:'getawaysFilter priceFilterWrapper',
					addAltFiltersClass:true
				},
				priceFilter : {
					title : 'Price',
					checkAll: true,
					elements: []
				},
				starFilter: {
					title: 'Star rating',
					inline: 'inline',
					showAll: true,
					checkAll: true,
					starIcon: true,
					elements: [
						{
							//dispName: '1',
							value: '5',
							svg: '<svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg>'
							//count:0
						},
						{
							//dispName: '2',
							value: '4',
							svg: '<svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg>'
							//count:0
						},
						{
							//dispName: '3',
							value: '3',
							svg: '<svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg>'
							//count:0
						},
						{
							//dispName: '4',
							value: '2',
							svg: '<svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg><svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg>'
							//count:0
						},
						{
							//dispName: '5',
							value: '1',
							svg: '<svg class="starGraphic"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#star"></use></svg>'
							//count:0
						}
					],
				},
				chain:{
					title: 'Hotel chain',
					inline: 'inline',
					showAll: true,
					checkAll: false,
					elements:[
								{ 
									chainName:"Chain Hotel1",
									value:"",
									chainCount:4
								},
								{
									chainName:"Chain Hotel2",
									value:"",
									chainCount:3
								},
								{
									chainName:"Chain Hotel3",
									"value":"",
									chainCount:3
								}
					],
					showMoreChains:1,
					smartFilterCheckBox:1,
					hideFilter: true,
					totalCount:""
				},
				payAtHotel: {
					title: '',
					inline: 'inline',
					hideFilter:true,
					showAll: false,
					checkAll: false,
					altFiltersClass:'specialFilter payAtHotelFilter',
					addAltFiltersClass:true,
					elements: [
						{
							dispName: '',
							dispNameTag:'<span rel="tTooltip" original-title="Only show hotels with<br/> a \'Pay at hotel\' facility">Pay at hotel</span>',
							iconNew:'pahGraphic',
							value: 'pah',
							count:0
						}
					]
				},
				showFewFilter:{
					title: 'Show few locations',
					checkAll: false,
					hideFilter:true,
					inline: 'inline',
					elements: [
						{
							value: 'showFewFilter',

						}]
				},
				
				showLocationHotels: {
					title: '',
					inline: 'inline',
					hideFilter:true,
					showAll: false,
					checkAll: false,
					altFiltersClass:'specialFilter showLocationHotelsFilter',
					addAltFiltersClass:true,
					elements: [
						{
							dispName: '',
							value: true
						}
					]
				},
				instantBooking: {
					title: '',
					inline: 'inline',
					hideFilter:true,
					showAll: false,
					checkAll: false,
					altFiltersClass:'specialFilter instantBookingFilter',
					addAltFiltersClass:true,
					elements: [
						{
							dispName: '',
							dispNameTag:'<span rel="tTooltip" original-title="Instant Book - Secure a reservation instantly">Instant booking</span>',
							dispNameTagBefore: '',
							value: 'ib'
						}
					]
				},
				deals: {
					title: 'Special offers',
					inline: 'inline',
					hideFilter:true,
					showAll:false ,
					altFiltersClass:'specialFilter dealsFilter',
					addAltFiltersClass:true,
					elements: [
						{
							dispName: '',
							dispNameTag:'<span>Hotel with deals </span>',
							iconNew: 'dealGraphic',
							value: 'deals',
							count:0
						}
					]
				},
				quickeys: {
					title: '',
					inline: 'inline',
					hideFilter:true,
					altFiltersClass:'specialFilter quickeysFilter',
					addAltFiltersClass:true,
					elements: [
						{
							dispName: '',
							dispNameTag:'<span>Quickeys</span>',
							value: 'quickeys',
							count:0
						}
					]
				},
				weSleep: {
					title: '',
					inline: 'inline',
					hideFilter:true,
					altFiltersClass:'specialFilter weSleepFilter',
					addAltFiltersClass:true,
					elements: [
						{
							dispName: '',
							dispNameTag:'<span>We sleep here</span>',
							value: 'weSleep',
							count:0
						}
					]
				},
				popHotels: {
					title: '',
					inline: 'inline',
					hideFilter:true,
					altFiltersClass:'specialFilter bestSellerFilter',
					addAltFiltersClass:true,
					elements: [
						{
							dispName: '',
							dispNameTag:'<span>Best sellers</span>',
							value: 'ctBookPerc'
						}
					]
				},
				roomType: {
					title: 'Room types',
					only: true,
					checkAll: true,
					hideFilter:true,
					showAll: true
				},
				freeCancellation : {
					title: '',
					titleHtmlTag:'',
					inline: 'inline',
					hideFilter:true,
					showAll: false,
					checkAll: false,
					elements: [
						{
							dispName: '',
							dispNameTag: '<span>Free cancellation</span>',
							iconNew: 'freeGraphic',
							value: 'fc',
							count:0
						}
					]
				},
				tripVilla : {
					title: '',
					titleHtmlTag:'',
					inline: 'inline',
					hideFilter:true,
					showAll: false,
					checkAll: false,
					elements: [
						{
							dispName: '',
							dispNameTag: '<span rel="tTooltip" original-title="These are properties which can be booked as a whole.<br> The fare includes all the rooms in the property.">Show only entire properties</span>',
							value: 'tv'
						}
					]
				},
				smallSearch: {
					clearFix:true,
					hideFilter:true,
					pCls:'col col23 clearField',
					inpCls:'fRight span span24 truncate',
					attr:'data-ul-class=hotelFilter data-optionsText=n data-autocomplete-ui=true data-selectionHandler=CT.utils.searchAreaPoi.addToLocalities  data-url=/places/hac?fcyids=&fic=0&s= data-responsemodifier=responseModifierHotel data-close=true data-closebtnonvalue=true',
					placeholder:'Filter by Hotel or Chain',
					imgItag:'<i class="search"></i>',
					clearField:'<a href="#" title="Clear" class="clearFieldAuto icon fRight" tabindex="-1"></a>'
				},
				amenity: {
					title: 'Amenities',
					iconNew: 'amenityGraphic',
					icon: 'amenitiesIcon',
					showMore:true,
					showAll:true
				},
				propertyType: {
					only: true,
					checkAll: true,
					showAll: true,
					showMore:true,
					title: 'Property types',
				},
				tagsFilter : {
					title: 'Tags filter',
					checkAll: false,
					hideCount: true,
					hideFilter: false
				},
				locality: {
					title: 'Popular in ',
					dynName: true,
					showMore: 'locations',
					moreLocationsClass:'locations',
					totCount: 5,
					showAll: false,
					showMore:false,
					hideFilter:true
				},
				lolfilter: {
					title: 'Popular in ',
					showMore: 'lolfilter',
					moreLocationsClass: 'lolfilter',
					showAll: false,
					checkAll: false,
					showMore: false,
					hideFilter: false
				},
				destinations: {
					title: 'Destinations',
					dynName: true,
					showMore: 'destinations',
					destinationsFilter:true,
					minCount:6,
					totCount: 20,
					altFiltersClass:'getawaysFilter destinationsFilterWrapper',
					addAltFiltersClass:true
				},
				destinationsTheme: {
					title: 'Experience',
					checkAll:false,
					altFiltersClass:'getawaysFilter experianceFilterWrapper',
					addAltFiltersClass:true
				},
				hotelsTheme: {
					title: 'Property type',
					checkAll:false,
					altFiltersClass:'getawaysFilter propertyFilterWrapper',
					addAltFiltersClass:true
				},
				dbg : {
					title : 'By Suppliers'
				},
				hrsFilterSlider :{min: 0,max: 10,step: 2,range: true,values:[0,10],title: 'Drive time',name:"hrsFilterSlider",altFiltersClass:'getawaysFilter distanceWrapper',addAltFiltersClass:true,hrsSlider:true}
			},

			srpFilterMap: [
				'sort',
				'sort_order',
				'starFilter',
				'chain',
				'payAtHotel',
				'showFewFilter',
				'showLocationHotels',
				'instantBooking',
				'deals',
				'quickeys',
				'weSleep',
				'popHotels',
				'roomType',
				'freeCancellation',
				'tripVilla',
				'smallSearch',
				'amenity',
				'propertyType',
				'tagsFilter',
				'locality',
				'destinations',
				'destinationsTheme',
				'hotelsTheme',
				'dbg',
				'hrsFilterSlider',
				'lolfilter',
				'priceFilter',
				'taStarRating',
				'hotelName',
				'price',
				'showFewFilter'
			],

			updatingMsgs : {
				hotel: {
					msg: "Updating hotels"
				}
			},

			smartness : {
				dateFormat : 'DD-MM-YYYY HH:mm:ss'
			},

			selectors : {
				resultTemplate : '.resultTemplate'
			},

			phoneNo : {
				customerService : '',
				phoneSales : ''
			},

			filters : {
				//filter acts only on this array of ids
				ids : "ids",
				//if ids is not passed, filters act only on loc ( array of attribute values )
				loc : "loc",
				//or condition for the following attribute list
				or : ["pt", "badgeFilter"],
				//and condition for the following attribute list
				and : ["am"],
				//range condition for the following attribute list
				range : ["price", "taStar", "star"],
				attrMap : {
					taStar : "data-tastar",
					star : "data-star",
					loc : "data-area-poi",
					price : "data-price",
					pt : "data-pt"
				},

				/**
				 * This map contains the list of filters nad its properties, grouped based on filter type
				 * This map is used in filter.updateFilters function.
				 * id > url parameter key
				 * el > element selector
				 * dataKey > is the property key in CT.settings which holds the slider range values; eg: CT.settings["hotel"+ filter.dataKey +"SliderObj"]
				 * dynamic > filter elements which gets created dynamically through the query params.
				 * secondary > denotes that the filter is in the secondary filters section.
				 * valueIndex > denotes the preferred index of the slider range values array. (many used for one range sliders)
				 */
				types:{
					chkBox:[	// checkbox filters
						{id:"area", el:".locality",dynamic:true},
						{id:"payAtHotel", el:".payAtHotel",dynamic:true},
						{id:"showLocationHotels", el:".showLocationHotels",dynamic:true},
						{id:"popHotels", el:".popHotels",dynamic:true},
						{id:"weSleep", el:".weSleep",dynamic:true},
						{id:"quickeys", el:".quickeys",dynamic:true},
						{id:"deals", el:".deals",dynamic:true},
						{id:"instantBooking", el:".instantBooking",dynamic:true},
						{id:"roomType", el:".roomType",dynamic:true},
						{id:"freeCancellation", el:".freeCancellation",dynamic:true},
						{id:"tripVilla", el:".tripVilla",dynamic:true},
						{id:"poi", el:".locality",dynamic:true},
						{id:"destinations", el:".destinations",dynamic:true},
						{id:"destinationsTheme", el:".destinationsTheme"},
						{id:"hotelsTheme", el:".hotelsTheme"},
						{id:"amenity", el:".amenity", secondary:true},
						{id:"propertyType", el:".propertyType", secondary:true},
						{id:"starFilter", el:".starFilter"},
						{id:"tagsFilter", el:".tagsFilter"},
						{id:"lolfilter", el:".lolfilter"},
						{id:"showFewLocationsFilter", el:".showFewLocationsFilter",dynamic:true},
						{id:"nearByCities", el:".nearByCities"},
						{id:"chain",el:".chain"}
					],
					slider:[	//slider filters
						{id:"price",el:".price.rangeSlider",dataKey:"Price"},
						{id:"hrsFilter",el:".distanceSlider.rangeSlider",dataKey:"Hrs"},
						{id:"taStarRating", el:".taStarRating.rangeSlider", rangeType:"max", dataKey:"TA",valueIndex:0},	// id-> param key, el -> filter selector
					],
					inputText:[
					    {id:"smallSearch", el:".smallSearch",dynamic:true}
					],
					tabs:[
						{id:"badgeFilter", el:".toolBarControls"}
					],
					textBox:[
						{id:"hotelName", el:".hotelName"}
					],
					radio:[{
						id:"taStarRating",el:".taStarRating"
					}]
				},
				constants:{
					locCheckboxText : "data-flt=area data-location=a",
					locAreaFilterCnt : 3,
					areaPoiRadius : 3,
					propertyHash : {
//						"BH" : "Boutique Hotel","GH" : "Guest House","HH" : "Heritage Hotel","HS" : "Homestay","RS" : "Resort","Hostel":"Hostel",
//						"SA" : "Serviced Apartment","SP" : "Spa","HB" : "Houseboat","CA" : "Casino","MOT" : "Motel","BNB" : "Bed and Breakfast",
//						"CAS" : "Castle","FRM" : "Farm","STE" : "Suites","EXT" : "Extended Stay","CTR" : "Conventions/Conference Center","APT" : "Apartment"
						
						"BH" : "Boutique Hotel",
						"GH" : "Guest House",
						"HH" : "Heritage Hotel",
						"HS" : "Homestay",
						"RS" : "Resort",
						"SA" : "Serviced Apartment",
						"SP" : "Spa",
						"HB" : "Houseboat",
						"CA" : "Casino",
						"MOT" : "Motel",
						"BNB" : "Bed and Breakfast",
						"CAS" : "Castle",
						"FRM" : "Farm",
						"STE" : "Suites",
						"EXT" : "Extended Stay",
						"CTR" : "Conventions/Conference Center",
						"VL"  : "Villa",
						"LYC" : "Luxury Yacht",
						"RJI" : "Ryokan (Japanese Inn)",
						"HST" : "Hostel",
						"CPG" : "Camping Ground",
						"APT" : "Apartment",
						"Hostel":"Hostel",
						"Apartment": "Apartment",
						"Dorm" : "Dorm",
						"House" : "House",
						"Villa" : "Villa",
						"Bed & Breakfast" :"Bed & Breakfast",
						"Treehouse":"Treehouse",
						"Tent":"Tent",
						"Loft":"Loft",
						"Chalet":"Chalet",
						"Other": "Other",
						"Castle":"Castle",
						"Boat" :"Boat",
						"Townhouse":"Townhouse",
						"Condominium":"Condominium",
						"Earth House":"Earth House",
						"GS":"GS",
						"Bungalow": "Bungalow",
						"BEA": "Beach Hut",
						"COT": "Cottage",
						"PAL": "Palace",
						"ASH": "Ashram/Dharamshala",
						"TRE": "Tree House",
						"SUI": "All Suites",
						"BUN": "Bungalow",
						"LOD": "Lodge",
						"VIP": "Rooms in a Property",
						"VIW": "Entire Property",
						"HOT": "Hotel"
					},
					airlineCombinations:{
						"9W-K":["9W-K","S2"]
					},
					poiShowData : ['Sights','Airport','HardCoded']
				}
			},
			placesUri : "/places/hac?&s=",
			/*gnStaticHotspotCities :{
								    "32550": [
								              {
								                  "nm": "Cubbonpet - Gandhi Nagar"
								              },
								              {
								                  "nm": "Sarjapur Road"
								              },
								              {
								                  "nm": "Banaswadi"
								              },
								              {
								                  "nm": "BTM"
								              },
								              {
								                  "nm": "Electronics City"
								              }
								          ],
								          "33719": [
								              {
								                  "nm": "Dadar - Worli - Parel"
								              },
								              {
								                  "nm": "Kalyan - Central Suburb"
								              }
								          ]
								      },*/
			gnShowPerSession : true,
			guidedNavDefaultShowCookieHrs : 2,
			guidedNavThreshold : 50,
			GnNumStripMinHotels : 20,
			GnNumStripMidHotels : 30,
			GnNumStripMaxHotels : 50,
			guidedNavScrollThreshold : 400,
			guidedNavEnabled : window.propGuidedNavEnabled,
			guidedNavForCTUsers : window.propGuidedNavForCTUsers,
			guidedNavForLog:{"price":7,"starFilter":8,"taStarRating":9,"locality":10,"propertyType":11,"amenity":12},
			lengthOfStay:10,
			totalDuration:100,
			taJsonExpiry : 30, // in minutes

			searchParamExceptionList : ["am", "badgeFilter", "loc", "price", "pt", "shortlisted", "star", "taStar","localities"],
			updateCallIndex : 1,
			sidResultsCallCount:1,

			//filterParamList : ["am", "badgeFilter", "loc", "price", "pt", "shortlisted", "star", "taStar"]
			filterParamList : ["amenity", "badgeFilter", "area", "poi", "price", "shortlisted", "starFilter", "taStarRating","chain","propertyType", "hotelName", "nearByCities","roomType","payAtHotel","tagsFilter", "lolfilter","showFewLocationsFilter","showLocationHotels","popHotels","weSleep","quickeys","deals","instantBooking","freeCancellation","tripVilla","smallSearch","destinations","hotelsTheme","destinationsTheme","hrsFilter","localities",'lolfilter','priceFilter','taStarRating','hotelName','price','showFewFilter'],
			firstRunObj : [
			                {"locations":{
							    "mainHeading":"Have a location in mind?",
							    "direction":"W",
							    "subHeading":"Find hotels exactly where you want",
							    "className":"locations"
							    }
							  },
							    {"weSleepHereFilter":{
								    "direction":"N",
								    "mainHeading":"We sleep here",
								    "subHeading":"Cleartrip employees vouch for hotels with this badge",
								    "className":"wsh"
								    }
							    },
							    {"ctBookPercentage":{
								    "direction":"N",
								    "upImg":true,
								    "mainHeading":"Best sellers",
								    "subHeading":"Spot the most booked hotels on Cleartrip",
								    "className":"bestSeller"
								    }
							    },
							    {"dealsFilter":{
								    "direction":"N",
								    "mainHeading":"Great savings",
								    "subHeading":"Filter out hotels with deals and save big",
								    "className":"deal"
								    }
							    },
							    {"locationSorter":{
								    "direction":"N",
								    "mainHeading":"Sort by Location",
								    "subHeading":"Filter out hotels with your location",
								    "className":"sorter"
								    }
							    },
							     {"quickKeysFilter":{
								    "direction":"N",
								    "upImg":true,
								    "mainHeading":"Quickeys",
								    "subHeading":"Get upto 30% off on last minute hotel bookings. Check-in today or tomorrow",
								    "className":"quickeys"
								    }
							    },
							    
							    {"dealSort":{
								    "direction":"N",
								    "mainHeading":"Sort by savings",
								    "subHeading":"Find the hotels with the greatest savings",
								    "className":"sorter"
								    }
							    },
							    {"mapView":{
								    "direction":"N",
								    "mainHeading":"Switch to map view",
								    "subHeading":"View hotels on map",
								    "className":"mapView"
								    }
							    },
							    {"primaryBar":{
								    "mainHeading":"Welcome to a brand new Cleartrip experience",
								    "direction":"N",
								    "subHeading":"",
								    "takeTour" : true
								    }
								}
						  ],
			firstRunEle :["locations","weSleepHereFilter","ctBookPercentage","dealsFilter","quickKeysFilter","dealSort","mapView","primaryBar"],
			updateCallback : {
				onload: [
					function openModal(hotelName, $currentTab) {
						var metaSearch = CT.cache[CT.settings.currentTab].searchParams.all;
						//check for trip advisor
						if(metaSearch.utm_source === undefined && hotelName != ''){
							if(metaSearch.referer_app !== undefined) {
								$currentTab.find('.hotelsList li.listItem:first .info h2 a.hotelDetails').trigger('click');
							}
							//$currentTab.find('.hotelsList li.listItem:first .info h2 a.hotelDetails').trigger('click');
						}else if(metaSearch.utm_source != undefined && hotelName != ''){
							$currentTab.find('.hotelsList li.listItem:first .info h2 a.hotelDetails').trigger('click');
						}
						else{
							/*if($currentTab.find('.hotelsList li.listItem:first').hasClass("disabled") === true){
								$currentTab.find('.hotelsList li.listItem:first').addClass("taNA");
							}*/
								$currentTab.find('.hotelsList li.listItem:first .info h2 a.hotelDetails').trigger('click');
						}
					},
					function showTipsy($currentTab) {
						/*$currentTab.find('.listViewSecondaryBar').tipsy({
							gravity : 'W',
							trigger: 'manual',
							addCloseButton: true,
							html : true,
							className : 'popOver light contentPopOver',
							opacity: 1,
							fallback: $('#WysiwypTpl').html()
						}).tipsy('show');
						$('.contentPopOver').css({ 'margin-left': '-10px', 'margin-top' : '-25px' });*/
					},
					function openModalForCheckAvail($currentTab){
						$currentTab.find("#"+CT.cache[window.parent.CT.settings.currentTab].roomChecked).find('.keyValue a.hotelDetails').first().trigger('click');
					},
					function showGnByDefault($currentTab){
						var isCTUser = unescape(CT.utils.cookies.read('userid')).indexOf('@cleartrip.com');
						var gnTriggered = false;
						if(CT.settings[CT.app].guidedNavEnabled && CT.cache[CT.settings.currentTab].isCitySearch === true && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
							  if(CT.settings[CT.app].guidedNavForCTUsers) {
								  if(isCTUser != -1){
									  //$(".viewSwitchers ul").addClass("col col8");
									  $(".powerFilters ul").addClass("span span12");
									  gnTriggered = true;
									  $currentTab.trigger('showGnBannerOnload');
								  }
									  
							  }else {
								  //$(".viewSwitchers ul").addClass("col col8");
								  $(".powerFilters ul").addClass("span span12");
								  $currentTab.trigger('showGnBannerOnload');
							  }
							  /*if(gnTriggered === false && (CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "34600" || CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "32550")){
								  $(".powerFilters ul").addClass("span span12");
								  $currentTab.trigger('showGnBannerOnload');
							  }*/
						  }
						
					}
				],
				always: [
					function updateUnavailableHotels($currentTab) {
						var html, tmp;
						if(window.productCode =="CP" || window.productCode =="AG"){
							html = CT.Mustache.to_html(CT.messages[CT.app].unavailable, { phoneSales: window.cpPhoneSales });
						}else{
							// html = CT.Mustache.to_html(CT.messages[CT.app].unavailable, { phoneSales: window.countryCode == "sa" ?"+971 4 3898888":window.ccNumber });
							html = CT.Mustache.to_html(CT.messages[CT.app].unavailable, { phoneSales: window.ccNumber });
						}

						_.forEach($currentTab.find('li.listItem.disabled'), function(disabledHotel, index) {
							var hotelTag = $(disabledHotel);
							if(CT.subProd != "wg"){
								hotelTag.removeClass('disabled').attr('data-price', '0').addClass('NA').find('li.rate').html('<i class="hotelSprite hotelRoomNA"></i>');
							
								tmp = hotelTag.find('.tools');
								tmp.find('.fLeft .openQuickLook').parent().remove();
								if(window.productCode =="AG"){
									tmp.find('.fRight').addClass('requestToBook');	
									html='<span class="buttonContainer">Keen on booking? <button type="button" class="action requestBooking">Request to book</button></span>';
								}
							
								tmp = tmp.find('.fRight');
								tmp.find('.openQuickLook').remove();
								tmp.html('').append(html);
							}else{
								hotelTag.removeClass('disabled').attr('data-price', '0').addClass('NA').find('div.hotelRate').html('<i class="hotelSprite hotelRoomNA"></i>');
								hotelTag.find("a.booking").hide();
							}
							
						});
					},
					function showAmenities($currentTab) {
						var tabCache = CT.cache[CT.settings.currentTab];
						var tmp;

						if($currentTab.find('.filtersForm .amenity input:checked').length > 0 && window.twoCol == false) {
							$currentTab.find('.hotelsList .listItem').addClass('opened showAmenities').find('.quickLook').show();
							$currentTab.find('.filtersForm .amenity').parent().parent().removeClass('closed').addClass('opened');
						}
						//commented out as the first hotel quick look should be open by default - karthik
						//else
							//$currentTab.find('.hotelsList .listItem').removeClass('opened showAmenities');
					}
				]
			},
			useMapMyIndia: false

		}
	})
});
